/** Minimum `point_count` for Mapbox cluster circle/count layers (matches tap logic). */
export const MAP_CLUSTER_POINT_COUNT_MIN = 2;

/**
 * Mapbox style filter: true multi-point cluster (`point_count` ≥ 2).
 * Server MVT tiles may emit `point_count: 1` on lone points — those must not use cluster UI.
 */
export const MAPBOX_MULTI_POINT_CLUSTER_FILTER = [
	"all",
	["has", "point_count"],
	[">=", ["to-number", ["get", "point_count"]], MAP_CLUSTER_POINT_COUNT_MIN],
] as const;

/**
 * Mapbox style filter: individual points (no cluster, or `point_count` < 2).
 */
export const MAPBOX_UNCLUSTERED_POINT_FILTER = [
	"!",
	MAPBOX_MULTI_POINT_CLUSTER_FILTER,
] as const;

/**
 * Combines two Mapbox GL filter expressions with `all`.
 *
 * @param base - Primary filter (e.g. cluster vs unclustered).
 * @param extra - Additional filter (e.g. sub-org scope).
 * @returns Combined filter, or whichever side is defined when the other is omitted.
 */
export function combineMapboxFilter(
	base: unknown[] | undefined,
	extra: unknown[] | undefined,
): unknown[] | undefined {
	if (extra == null) return base;
	if (base == null) return extra;
	return ["all", base, extra];
}
